const units = require('./DeviceUnits');
const categoryLabels = require('./DeviceLabels');

module.exports = {
  name: 'DeviceValue',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    isTemperatureShown() {
      return [11, 34].includes(this.item.functype) && this.item.sensorvalue != undefined;
    },
    temperatureCelsius() {
      let t = this.item.sensorvalue * 0.1;
      if (t) {
        if (this.item.unit == 2)
          t = (t - 32) * 5 / 9;
        return t.toFixed(1);
      }
      return '---';
    },
    temperatureFahrenheit() {
      let t = this.item.sensorvalue * 0.1;
      if (t) {
        if (this.item.unit == 1) t = t * 9 / 5 + 32;
        return t.toFixed(0);
      }
      return '---';
    },
    isSensorValueShown() {
      return [12, 15].includes(this.item.functype) && this.item.sensorvalue != undefined;
    },
    displaySensorUnit() {
      return units.names[this.item.unit];
    },
    isTimestampShown() {
      return [14, 28].includes(this.item.functype) && this.item.timestamp;
    },
    isDoorSensorShown() {
      return this.item.functype == 13 && this.item.basicvalue != undefined;
    },
    statusDoor() {
      return categoryLabels[13][this.item.basicvalue > 0 ? 100 : 0];
    },
    isFloodShown() {
      return [17, 20, 25].includes(this.item.functype) && this.item.basicvalue != undefined;
    },
    statusFlood() {
      return categoryLabels[20][this.item.basicvalue > 0 ? 100 : 0];
    },
    isGlassShown() {
      return this.item.functype == 21 && this.item.basicvalue != undefined;
    },
    statusGlass() {
      return categoryLabels[21][this.item.basicvalue > 0 ? 100 : 0];
    },
    isSwitchShown() {
      return [23, 36].includes(this.item.functype) && this.item.basicvalue != undefined;
    },
    statusSwitch() {
      return categoryLabels[23][this.item.basicvalue > 0 ? 100 : 0];
    },
    isBasicValueShown() {
      return [24, 26, 30, 41].includes(this.item.functype) && this.item.basicvalue != undefined;
    },
    isLockShown() {
      return this.item.functype == 31 && this.item.basicvalue != undefined;
    },
    statusLock() {
      return categoryLabels[31][this.item.basicvalue > 0 ? 100 : 0];
    },
    isFanShown() {
      return this.item.functype == 32 && this.item.sensorvalue != undefined;
    },
    statusFan() {
      return categoryLabels[32][this.item.sensorvalue];
    },
    isModeShown() {
      return this.item.functype == 33 && this.item.sensorvalue != undefined;
    },
    statusMode() {
      return categoryLabels[33][this.item.sensorvalue];
    },
    isMeterShown() {
      return [22, 29].includes(this.item.functype) && this.item.meter;
    }
  },
  template: `
<v-list-tile-sub-title class="black--text">
  <div v-if="isTemperatureShown"><b>{{ temperatureCelsius }}</b> <small class="grey--text">°C</small> <b class="ml-3">{{ temperatureFahrenheit }}</b> <small class="grey--text">°F</small></div>
  <div v-if="isMeterShown"><b>{{ item.meter.watt/10 }}</b> <small class="grey--text">W</small> <b class="ml-3">{{ item.meter.kwh/100 }}</b> <small class="grey--text">kWh</small></div>
  <div v-if="isSensorValueShown"><b>{{ item.sensorvalue }}</b> <small class="grey--text">{{ displaySensorUnit }}</small></div>
  <div v-if="isBasicValueShown"><b>{{ Math.min(item.basicvalue,100) }}</b> <small class="grey--text">%</small></div>
  <div v-if="isTimestampShown">{{ new Date(item.timestamp*1000).toLocaleString() }}</div>
  <div v-if="isDoorSensorShown">{{ statusDoor ? $t(statusDoor) : '---' }}</div>
  <div v-if="isFloodShown">{{ statusFlood ? $t(statusFlood) : '---' }}</div>
  <div v-if="isGlassShown">{{ statusGlass ? $t(statusGlass) : '---' }}</div>
  <div v-if="isSwitchShown">{{ statusSwitch ? $t(statusSwitch) : '---' }}</div>
  <div v-if="isLockShown">{{ statusLock ? $t(statusLock) : '---' }}</div>
  <div v-if="isFanShown">{{ statusFan ? $t(statusFan) : '---' }}</div>
  <div v-if="isModeShown">{{ statusMode ? $t(statusMode) : '---' }}</div>
</v-list-tile-sub-title>
  `
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/luffanet-web-components/DeviceValue.js
// module id = Kt3u
// module chunks = 0